import type { ReactNode } from 'react'

export default function InfoPanel({
  values,
}: {
  values: (ReactNode | string)[]
}) {
  return (
    <div className='flex w-fit rounded-xl border border-neutral200'>
      {values.map((value, index) => (
        <div
          className={index === 0 ? '' : 'border-l border-neutral200'}
          key={`info-panel-${index}`}
        >
          <div className='p-4' key={`info-panel-${index}`}>
            {value}
          </div>
        </div>
      ))}
    </div>
  )
}
